exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-nav[data-v-81b4ab5c]{height:80px;position:fixed;bottom:0;left:0;right:0;z-index:100;border-top:1px solid var(--border-primary)}.footer-nav.is-hidden[data-v-81b4ab5c]{display:none}", ""]);

// exports
